import React from 'react'
import useQueryString from '../../../hooks/use-query-string'
import styles from './OrderStatus.module.scss'
import OrderStatusForm from './OrderStatusForm'
import OrderPreview from './OrderPreview'

export default function OrderStatus() {
  const { orderId, email, studentFirstName, studentLastName, no_order_found } = useQueryString()

  return (
    <div className={styles.page}>
      {no_order_found && (
        <h4 className={styles.noOrderFound}>
          No order was found with that given information. Please double check the entered information or call us for assistance.
        </h4>
      )}
      {!(email || studentFirstName || studentLastName) && <OrderStatusForm />}
      {(orderId || (studentFirstName && studentLastName)) && email && <OrderPreview />}
    </div>
  )
}
